import { HttpMethods, makeRequest } from '../helpers/http.helper';
import {
  CollectionSiteStatisticsPeriodParams,
  PatchCollectionSiteStatisticsRequest,
} from '../types/collection-site-statistics.type';

export const getCollectionSiteStatistics = (
  organizationId: string,
  collectionSiteId: string,
  period: CollectionSiteStatisticsPeriodParams
) =>
  makeRequest({
    url: `/dashboard/organization/${organizationId}/collection_site/${collectionSiteId}/statistics`,
    method: HttpMethods.GET,
    params: { year: period.year, month: period.month },
  });

export const patchCollectionSiteStatistics = (
  organizationId: string,
  collectionSiteId: string,
  period: CollectionSiteStatisticsPeriodParams,
  body: PatchCollectionSiteStatisticsRequest
) =>
  makeRequest({
    url: `/dashboard/organization/${organizationId}/collection_site/${collectionSiteId}/statistics`,
    method: HttpMethods.PATCH,
    params: { year: period.year, month: period.month },
    data: body,
  });
